import React from 'react'
import SVGIcon from '../../svg/SVGIcon'
import useEventCallback from '../../utils/useEventCallback'
import s from './CloseUserAreaButton.less'
import { useAction } from '../../utils/react-redux'
import { navigateBack } from '../../../store/history/history.actions'

const CloseUserAreaButton = () => {
  const execNavigateBack = useAction(navigateBack)
  const onClose = useEventCallback(execNavigateBack)

  return (
    <div className={s.closeBtn} onClick={onClose}>
      <SVGIcon icon={'croix-android'} />
    </div>
  )
}

export default CloseUserAreaButton
